import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHome, FaBuilding, FaArrowLeft, FaLightbulb } from 'react-icons/fa';
import './PGorRentDialog.css';

function PGorRentDialog() {
  const navigate = useNavigate();

  const handlePGClick = () => {
  navigate('/homepage/list-your-space'); // 🔁 Redirect to House Listing Form
  };

  const handleRentClick = () => {
    navigate('/homepage/list-rent');
  };

  const handleBack = () => {
    navigate('/homepage/profile');
  };

  return (
    <div className="pg-dialog-wrapper">
      <div className="pg-dialog-box">
        <button className="back-button" onClick={handleBack}>
          <FaArrowLeft /> Back
        </button>

        <h2 className="pg-dialog-title">What would you like to list?</h2>

        <div className="pg-dialog-options">
          <button className="pg-dialog-btn" onClick={handlePGClick}>
            <FaBuilding className="pg-dialog-icon" />
            PG
          </button>
          <button className="pg-dialog-btn" onClick={handleRentClick}>
            <FaHome className="pg-dialog-icon" />
            Rental Space
          </button>
        </div>

        <div className="pg-instruction-card">
          <h3><FaLightbulb className="instruction-icon" /> How to List Your Property</h3>
          <ul className="pg-instruction-list">
            <li>📝 Fill out basic details about your PG or Rental space.</li>
            <li>📸 Upload clear images of rooms and facilities.</li>
            <li>📍 Select your exact location on the map.</li>
            <li>✅ Submit for verification and go live.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PGorRentDialog;
